module.exports = __webpack_public_path__ + "static/img/zipteam-icon.dcc0cc0c.svg";